import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface EmailFieldProps {
    register: UseFormRegisterReturn;
    error?: string;
    disabled?: boolean;
    id?: string;
}

const EmailField = ({ register, error, disabled = false, id }: EmailFieldProps) => {
    return (
        <div className="form-control">
            <label className="label h-7" htmlFor={id}>
                <span className="text-base-content">Email Address</span>
            </label>
            <input
                {...register}
                id={id}
                type="email"
                placeholder="name@email.com"
                className={`input input-bordered bg-base-100 h-9 text-sm ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${
                    error ? "input-error" : ""
                }`}
                disabled={disabled}
                maxLength={100}
            />
            {error && <p className="text-error text-xs mt-1">{error}</p>}
        </div>
    );
};

export default EmailField;
